import { ID } from '../../utils/codecUtils';
import { listResponse } from '../../utils/listResponse';
import { TriggerEventType } from '../models/trigger';
import { triggerSchema } from '../models/trigger.schema';
import { triggersListQuerySchema } from './list.schema';

export type TriggersListQuery = Partial<{
  id: ID;
  queue: ID;
  event: TriggerEventType;
}>;

export const list = (query: TriggersListQuery) => {
  return {
    endpoint: '/triggers',
    method: 'GET',
    responseSchema: listResponse(triggerSchema),
    query,
    querySchema: triggersListQuerySchema,
  } as const;
};
